var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-class"},[_c('span',{staticClass:"c-class__header"},[_vm._v("知识点班级对比")]),_c('div',{staticClass:"c-class__bgc"},[_vm._m(0),(_vm.show)?_c('EmptyLearning'):_vm._e()],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"class-compare"},[_c('div',{staticClass:"class-compare-data",attrs:{"id":"class-compare-data"}})])
}]

export { render, staticRenderFns }